import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalUpdateCollectionMemoStoreInterface {
  bibliographyRealId: number
  collectionId: number
  onUpdatedCallback?: (
    workMemo: string,
    displayMemo: string,
    localMemo: string
  ) => void
}

@Module({
  name: 'ModalUpdateCollectionMemoStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalUpdateCollectionMemoStore extends BaseStore {
  _isOpen: boolean = false

  _bibliographyRealId: number = 0

  _collectionId: number = 0

  _updatedCallback?: (
    workMemo: string,
    displayMemo: string,
    localMemo: string
  ) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get bibliographyRealId(): number {
    return this._bibliographyRealId
  }

  get collectionId(): number {
    return this._collectionId
  }

  @Mutation
  public open(params: ModalUpdateCollectionMemoStoreInterface) {
    this._isOpen = true
    this._bibliographyRealId = params.bibliographyRealId
    this._collectionId = params.collectionId
    this._updatedCallback = params?.onUpdatedCallback
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public updated(memo: {
    workMemo: string
    displayMemo: string
    localMemo: string
  }): void {
    if (this._updatedCallback) {
      this._updatedCallback(memo.workMemo, memo.displayMemo, memo.localMemo)
    }

    this._isOpen = false
  }
}
